import feathers from '@feathersjs/client'
// import hooks from 'feathers-hooks'
// import rest from './rest'
import sockets from './sockets'

const client = feathers()
  // .configure(rest)
  .configure(sockets)
  // .configure(hooks())

client.getService = name => client.service(`api/${name}`)

export default client



// WEBPACK FOOTER //
// ./src/store/client/index.js